/**
 * "The timer changed" — announced by whoever changed it, heard by everyone showing it.
 *
 * THREE PLACES CAN START AND STOP THE ONE TIMER: the task drawer, the timesheet's bar, and the
 * chip in the shell. Polling alone is not synchronisation. The chip refreshes every minute,
 * which is fine for a tab that has been sitting idle — and useless when the bar directly above
 * it has just stopped the timer, because for up to a minute afterwards the shell goes on
 * showing a clock for something that is no longer running. That is worse than not showing it:
 * a stale clock is indistinguishable from a live one.
 *
 * So the poll stays as a floor for changes made in ANOTHER TAB, and this covers the case the
 * poll is bad at — a change made in this one, where it should be instant.
 *
 * Deliberately not a context or a store. There is no state here to get out of step; it is a
 * nudge that says "ask again", and the answer always comes from the server.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

/** Call after anything that starts or stops the timer. */
export function timerChanged(): void {
  for (const listener of [...listeners]) listener();
}

/** Subscribe. Returns the unsubscribe, for a `useEffect` cleanup. */
export function onTimerChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
